import { render } from "./MarkdownExcerpt.vue?vue&type=template&id=22741ede&scoped=true&ts=true"
import script from "./MarkdownExcerpt.vue?vue&type=script&lang=ts"
export * from "./MarkdownExcerpt.vue?vue&type=script&lang=ts"

import "./MarkdownExcerpt.vue?vue&type=style&index=0&id=22741ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22741ede"]])

export default __exports__